// extracted by mini-css-extract-plugin
module.exports = {"webform":"WebformView_webform__3zmc3","toolbar":"WebformView_toolbar__2zVQf","headerButton":"WebformView_headerButton__3T2VM","spinner":"WebformView_spinner__1bp02"};